export default "__VITE_ASSET__Cgz6GiSY__"